export default __webpack_public_path__ + "static/media/Gerald&EllenKitchen400.8df2086e.jpg";